module.exports = __webpack_public_path__ + "img/coupon-invalid.c82e45ca.png";